/**
 * Minimal client-side cookie reader for the React-UI rollout
 * (`ui_variant`, `cochat_anon_id`). Shared by the PostHog and Faro init paths so
 * the parsing stays consistent. Decoding is best-effort: a corrupt cookie value
 * returns `undefined` rather than throwing and breaking telemetry init.
 */
export function readCookie(name: string): string | undefined {
	if (typeof document === 'undefined') {
		return undefined;
	}
	const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
	const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${escaped}=([^;]*)`));
	const value = match?.[1];
	if (value === undefined) {
		return undefined;
	}
	try {
		return decodeURIComponent(value);
	} catch {
		return undefined;
	}
}

/**
 * Read the server-assigned UI variant, validated to a known value. The cookie is
 * user-controlled, so an arbitrary/tampered value must never be registered as a
 * telemetry property (it would pollute the rollout's funnels/guardrails).
 */
export function readUiVariant(): 'react' | 'control' | undefined {
	const value = readCookie('ui_variant');
	return value === 'react' || value === 'control' ? value : undefined;
}
